
export const defaultStateValue = ({state, getDefaultValue}) => ({
    onChange: state.onChange,
    value: getDefaultValue(state.value),
    change: (fn) => state.change((oldValue) => fn(getDefaultValue(oldValue))),
});
